// Recovered compiled webpack factory 54089. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  function r(e) {
    return null !== e && "object" == typeof e && "then" in e && "function" == typeof e.then;
  }
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "isThenable", {
      enumerable: !0,
      get: function () {
        return r;
      },
    }));
}
